import { useState } from 'react';

interface Props {
  memberName: string;
  placeCount: number;
  boatCount: number;
  onConfirm: (deleteBoats: boolean) => void | Promise<void>;
  onCancel: () => void;
}

export default function DeleteMemberDialog({
  memberName,
  placeCount,
  boatCount,
  onConfirm,
  onCancel,
}: Props) {
  const [deleteBoats, setDeleteBoats] = useState(false);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50"
    >
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full space-y-4">
        <h2 className="text-lg font-bold">Radera medlem permanent?</h2>
        <p>
          Du är på väg att radera <strong>{memberName}</strong>.
        </p>
        <ul className="text-sm text-gray-700 list-disc ml-5 space-y-1">
          <li>{placeCount} båtplats(er) får ingen ägare</li>
          <li>{boatCount} båt(ar) frikopplas (ingen ägare, ingen plats)</li>
        </ul>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={deleteBoats}
            onChange={(e) => setDeleteBoats(e.target.checked)}
          />
          Radera även båtarna permanent
        </label>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded"
          >
            Avbryt
          </button>
          <button
            type="button"
            onClick={() => void onConfirm(deleteBoats)}
            className="px-4 py-2 bg-red-700 text-white rounded"
          >
            Radera permanent
          </button>
        </div>
      </div>
    </div>
  );
}
